// Shared persistent state for the two Analytics pages (Dashboard + Candidates List).
// Both pages read from and write to this object.
// Reset by calling resetAnalyticsSession() — triggered when either page unmounts
// to a non-analytics route.

const ANALYTICS_PATHS = ['/dashboards', '/dashboards/candidate-metric-details']

export const analyticsSession = {
  // Dashboard filter state
  dashboard: {
    institute_campus_id: null,
    institute_campus_name: null,
    institute_campus_option: null,
    corporate_id: null,
    corporate_name: null,
    corporate_option: null,
  },
  // Candidates list filter state
  candidates: {
    filters: null,
    searchValue: '',
  },
}

export function resetAnalyticsSession() {
  analyticsSession.dashboard = {
    institute_campus_id: null,
    institute_campus_name: null,
    institute_campus_option: null,
    corporate_id: null,
    corporate_name: null,
    corporate_option: null,
  }
  analyticsSession.candidates = { filters: null, searchValue: '' }
}

// Call this in a useEffect cleanup inside each analytics page component.
// window.location.pathname is already updated to the next route when cleanup fires.
export function resetSessionIfLeavingAnalytics() {
  const nextPath = window.location.pathname
  const staying = ANALYTICS_PATHS.some(p => nextPath.startsWith(p))
  if (!staying) resetAnalyticsSession()
}
